module.exports = __webpack_public_path__ + "static/media/cipla_logo_footer.93637bac.png";